import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import { FIELDS, TOAST_MESSAGES } from "../../../constants/SiteConstants";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import {
  deleteData,
  fetchProductData,
  getCurrentData,
} from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";
import Loader from "../../../components/commonComponent/Loader";
import { BsCartPlus } from "react-icons/bs";

const API_URL = process.env.REACT_APP_API_URL;

const columns = [
  { header: FIELDS.TITLE, accessor: "title" },
  { header: FIELDS.SLUG, accessor: "slug" },
  { header: FIELDS.BRIEF_DESCRIPTION, accessor: "briefDescription" },
  { header: FIELDS.DESCRIPTION, accessor: "description" },
];

const ITEMS_PER_PAGE = 10;

const Products = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const { loading, showLoader, hideLoader } = useLoader();

  const {
    showDeleteModal,
    showViewModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.length >= 2 || searchTerm === "") {
      fetchProductData(
        `${API_URL}/products/getAllProducts`,
        setData,
        setError,
        setFilteredData,
        currentPage,
        searchTerm,
        showLoader,
        hideLoader
      );
    }
  }, [currentPage, searchTerm]);

  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2) {
      setSearchTerm(searchValue);
      setCurrentPage(1);
    } else if (searchValue.length === 0) {
      setSearchTerm("");
      setCurrentPage(1);
    }
  };

  const handleDeleteConfirm = () => {
    deleteData(`${API_URL}/products/deleteProduct`, selectedItem._id, setError)
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => item._id !== selectedItem._id)
        );
        toast.success(TOAST_MESSAGES.DELETED);
        fetchProductData(
          `${API_URL}/products/getAllProducts`,
          setData,
          setError,
          setFilteredData,
          currentPage,
          searchTerm,
          showLoader,
          hideLoader
        );
      })
      .catch((error) => {
        setError(error);
        toast.error(TOAST_MESSAGES.ERROR_DELETE);
      });
    handleCloseDeleteModal();
  };

  const totalPages = Math.ceil((filteredData?.length || 0) / ITEMS_PER_PAGE);
  const currentData = getCurrentData(
    Array.isArray(filteredData) ? filteredData : [],
    currentPage,
    ITEMS_PER_PAGE
  );

  const fieldsToShow = {
    Title: "title",
    Slug: "slug",
    "Brief Description": "briefDescription",
    Description: "description",
    Image: "images",
  };

  return (
    <div>
      <h2 className="capitalize font-bold text-[24px] mb-4">Products List</h2>

      <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
        <div className="flex items-center">
          <div className="search-filter-container">
            <Search
              searchFields={["First Name", "Last Name", "Email"]}
              onSearch={handleSearch}
            />
          </div>
        </div>

        <Link
          to="/products/add"
          className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
        >
          Add Product
        </Link>
      </div>

      <div className="table-container">
        {filteredData?.length > 0 ? (
          <>
            <Table
              columns={columns}
              data={currentData}
              showIndex={true}
              currentPage={currentPage}
              itemsPerPage={ITEMS_PER_PAGE}
              onDelete={handleOpenDeleteModal}
              onUpdate={(item) => navigate(`/products/edit/${item._id}`)}
              onView={handleOpenViewModal}
              actions={{
                showView: true,
                showEdit: true,
                showDelete: true,
                customActions: [
                  {
                    label: <span className="text-xl text-black"><BsCartPlus /></span>,
                    onClick: (item) => navigate(`/products/marketplace/${item._id}`),
                    buttonClass: "text-blue-500 hover:blue-600 text-white", // optional, for custom styling
                  },
                ],
              }}
              
              loading={loading}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </>
        ) : (
          <div className="text-center py-4">
            <Loader />
          </div>
        )}
      </div>
      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDeleteConfirm}
      />

      <ViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />
    </div>
  );
};

export default Products;
